import * as React from 'react';


/**
 * @author NikolaV
 */

export const VehicleListItem: React.FC<{
    vehicle: IVehicle,
    onClick?: (vehicle: IVehicle) => void
}> = ({ vehicle, onClick }) => {
    const className = `vehicle-color vehicle-color-${vehicle.statusColor}`;

    return (
        <div data-id={vehicle.id}
             onClick={onClick ? () => onClick(vehicle) : null}
             className={vehicle.position?.latitude && vehicle.activeProject?.id === kuura.getProjectId() ? 'clickable' : null}>

            <span className={className} title={vehicle.statusDescription}/>
            {vehicle.name}
        </div>
    );
};
